import { render, staticRenderFns } from "./main-search.vue?vue&type=template&id=f4517a70&"
import script from "./main-search.vue?vue&type=script&lang=js&"
export * from "./main-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports